import { Link } from 'react-router-dom'
import {Mail, MapPin, Linkedin, Facebook, Twitter} from 'lucide-react'

function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg overflow-hidden flex items-center justify-center">
                <img
                  src="https://static.lumi.new/45/453d999b1649f9653bad32d711e693eb.png"
                  alt="Delta Facilities logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col">
                <span className="font-display text-white text-lg font-bold leading-none">Delta</span>
                <span className="text-[10px] uppercase tracking-[0.2em] text-white/60 leading-none mt-1">Facilities</span>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              One partner for all your facility needs. Consistent, high-quality service at scale, across Canada.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-orange-accent flex items-center justify-center transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-orange-accent flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-orange-accent flex items-center justify-center transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 font-semibold mb-5">Services</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services" className="text-white/80 hover:text-orange-accent transition-colors">Janitorial Services</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-orange-accent transition-colors">Building Maintenance</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-orange-accent transition-colors">Day Porter Services</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-orange-accent transition-colors">Exterior Cleaning</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-orange-accent transition-colors">Post-Construction</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 font-semibold mb-5">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="text-white/80 hover:text-orange-accent transition-colors">About Us</Link></li>
              <li><Link to="/industries" className="text-white/80 hover:text-orange-accent transition-colors">Industries</Link></li>
              <li><Link to="/service-areas" className="text-white/80 hover:text-orange-accent transition-colors">Service Areas</Link></li>
              <li><Link to="/quote" className="text-white/80 hover:text-orange-accent transition-colors">Request a Quote</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-orange-accent transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 font-semibold mb-5">Get in Touch</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/80">
                <Mail className="w-4 h-4 mt-0.5 text-orange-accent flex-shrink-0" />
                <span>info@deltafacilitiesservices.com</span>
              </li>
              <li className="flex items-start gap-3 text-white/80">
                <MapPin className="w-4 h-4 mt-0.5 text-orange-accent flex-shrink-0" />
                <span>Nationwide coverage<br/>across Canada</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-white/50 text-xs tracking-wide">© {new Date().getFullYear()} Delta Facilities Services. All rights reserved.</p>
          <div className="flex gap-6 text-xs text-white/50">
            <a href="#" className="hover:text-orange-accent transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-orange-accent transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-orange-accent transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
